<template>
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header">
                    <span class="card-title p-0 m-0">Edit Appointment <a href="/admin/appointments" class="btn btn-sm btn-theme float-end">View Appointments</a></span>
                </div>
                <div class="card-body">
                    <form class="">
                        <div class="row g-3">
                            <div class="col-md-4">
                                <label for="event_title" class="form-label">Event Title<span class="text-danger">*</span></label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter Event Title"
                                    v-model="appointment.title"
                                    :class="{ 'is-invalid': !isValidated && appointment.title==='' }"
                                >
                                <div class="is-invalid invalid-feedback">This field is required.</div>
                            </div>
                            <div class="col-md-4">
                                <label for="name" class="form-label">Full Name<span class="text-danger">*</span></label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter Full Name"
                                    v-model="appointment.name"
                                    :class="{ 'is-invalid': !isValidated && appointment.name==='' }"
                                >
                                <div class="is-invalid invalid-feedback">This field is required.</div>
                            </div>
                            <div class="col-md-4">
                                <label for="email" class="form-label">Email</label>
                                <input type="email" class="form-control" placeholder="Enter Email" v-model="appointment.email">
                            </div>
                            <div class="col-md-4">
                                <label for="phone_number" class="form-label">Phone Number</label>
                                <input type="number" class="form-control" placeholder="Enter Phone Number" v-model="appointment.phone_number">
                            </div>
                            <div class="col-md-4">
                                <label for="event_location" class="form-label">Location</label>
                                <input type="text" class="form-control" placeholder="Enter Event Location" v-model="appointment.location">
                            </div>
                            <div class="col-md-4">
                                <label for="meeting_link" class="form-label">Meeting Link</label>
                                <input type="text" class="form-control" placeholder="Enter Meeting Link" v-model="appointment.meeting_link">
                            </div>
                        </div>
                        <div class="row g-3 mt-1">
                            <div class="col-md-4">
                                <label for="event_date" class="form-label">Event Date<span class="text-danger">*</span></label>
                                <BookingDatePicker
                                    v-model="appointment.appointment_date"
                                    :format="'dd-MM-yyyy'"
                                    :time-picker="false"
                                    :display-marker="false"
                                ></BookingDatePicker>
                            </div>
                            <div class="col-md-4">
                                <label for="event_time" class="form-label">Start Time<span class="text-danger">*</span></label>
                                <VueDatePicker
                                    v-model="appointment.start_time"
                                    time-picker :is-24="false"
                                    :clearable="false"
                                    :minutes-grid-increment="10"
                                    :minutes-increment="15"
                                >
                                    <template #input-icon>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clock-11 hm-time-icons"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 9.5 8"/></svg>
                                    </template>
                                </VueDatePicker>
                            </div>
                            <div class="col-md-4">
                                <label for="event_time" class="form-label">Finish Time<span class="text-danger">*</span></label>
                                <VueDatePicker
                                    v-model="appointment.end_time"
                                    time-picker :is-24="false"
                                    :clearable="false"
                                    :minutes-grid-increment="10"
                                    :minutes-increment="15"
                                >
                                    <template #input-icon>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clock-11 hm-time-icons"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 9.5 8"/></svg>
                                    </template>
                                </VueDatePicker>
                            </div>
                        </div>
                        <div class="row g-3 mt-1">

                            <!--<div class="col-md-6">
                                <label for="address" class="form-label">Event Address<span class="text-danger">*</span></label>
                                <input type="text" class="form-control" placeholder="Enter Event Address" v-model="appointment.address">
                            </div>-->
                            <!--<div class="col-md-6">
                                <label for="event_timezone" class="form-label">Timezone<span class="text-danger">*</span></label>
                                <Select2
                                    v-model="appointment.timezone"
                                    :options="timezones"
                                    :settings="{ placeholder: 'Select Timezone'}"
                                />
                            </div>-->
                            <div class="col-md-4">
                                <label for="name" class="form-label">Assign To</label>
                                <vue-multiselect
                                    v-model="appointment.assigned_to"
                                    :options="userOptions"
                                    placeholder="Search staff"
                                    :show-labels="false"
                                    track-by="name_with_email"
                                    label="name_with_email"
                                    :multiple="true"
                                ></vue-multiselect>
                            </div>
                            <div class="col-md-4">
                                <label for="name" class="form-label">Status</label>
                                <vue-select
                                    v-model="appointment.status"
                                    :items="[{id: '1', name: 'Active'}, {id: '0', name: 'Cancelled'}]"
                                    placeholder="Select Status"
                                    :show-labels="false"
                                    track-by="id"
                                    label="name"
                                    :multiple="false"
                                    :searchable="false"
                                ></vue-select>
                            </div>
                            <div class="col-md-4">
                                <label for="event_description" class="form-label">Description</label>
                                <textarea class="form-control" placeholder="Enter Event Description" rows="3" v-model="appointment.description"></textarea>
                            </div>
                            <div class="col-12">
                                <button
                                    type="button"
                                    class="btn btn-theme float-end"
                                    :class="{ 'disabled': processing }"
                                    :disabled="processing"
                                    v-text="processing ? 'Processing...' : (appointment.id != '' ? 'Update' : 'Create')"
                                    @click="createOrAppointment"
                                ></button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
import Select2 from 'vue3-select2-component';
import BookingDatePicker from "./BookingDatePicker";
import VueSelect from './partials/VueSelect.vue';

export default {
    name: 'Appointment',
    components: {
        Select2,
        BookingDatePicker,
        VueSelect
    },
    props: {
        appointmentData: {
            type: Object,
            default: () => {
                return {
                    provider_id: '',
                    id: '',
                    title: '',
                    description: '',
                    name: '',
                    email: '',
                    phone_number: '',
                    address: '',
                    appointment_date: new Date(),
                    start_time: {hours: 9, minutes: 0},
                    end_time: {hours: 17, minutes: 0},
                    location: '',
                    meeting_link: '',
                    assigned_to: [],
                    status: '1',
                    timezone: 'Europe/London',
                }
            }
        }
    },
    data() {
        return {
            processing: false,
            addOrEdit: this.$props.appointmentData.id != '' ? 'edit' : 'add',
            appointment: {
                provider_id: '',
                id: '',
                title: '',
                description: '',
                name: '',
                email: '',
                phone_number: '',
                address: '',
                appointment_date: new Date(),
                start_time: {hours: 9, minutes: 0},
                end_time: {hours: 17, minutes: 0},
                location: '',
                meeting_link: '',
                assigned_to: [],
                status: '1',
                timezone: 'Europe/London',
            },
            timezones: [
                {"id": "Pacific/Niue", "text": "(GMT-11:00) Niue"},
                {"id": "Pacific/Pago_Pago", "text": "(GMT-11:00) Pago Pago"},
                {"id": "Pacific/Honolulu", "text": "(GMT-10:00) Hawaii Time"},
                {"id": "Pacific/Rarotonga", "text": "(GMT-10:00) Rarotonga"},
                {"id": "Pacific/Tahiti", "text": "(GMT-10:00) Tahiti"},
                {"id": "Pacific/Marquesas", "text": "(GMT-09:30) Marquesas"},
                {"id": "America/Anchorage", "text": "(GMT-09:00) Alaska Time"},
                {"id": "Pacific/Gambier", "text": "(GMT-09:00) Gambier"},
                {"id": "America/Los_Angeles", "text": "(GMT-08:00) Pacific Time"},
                {"id": "America/Tijuana", "text": "(GMT-08:00) Pacific Time - Tijuana"},
                {"id": "America/Vancouver", "text": "(GMT-08:00) Pacific Time - Vancouver"},
                {"id": "America/Whitehorse", "text": "(GMT-08:00) Pacific Time - Whitehorse"},
                {"id": "Pacific/Pitcairn", "text": "(GMT-08:00) Pitcairn"},
                {"id": "America/Dawson_Creek", "text": "(GMT-07:00) Mountain Time - Dawson Creek"},
                {"id": "America/Denver", "text": "(GMT-07:00) Mountain Time"},
                {"id": "America/Edmonton", "text": "(GMT-07:00) Mountain Time - Edmonton"},
                {"id": "America/Hermosillo", "text": "(GMT-07:00) Mountain Time - Hermosillo"},
                {"id": "America/Mazatlan", "text": "(GMT-07:00) Mountain Time - Chihuahua, Mazatlan"},
                {"id": "America/Phoenix", "text": "(GMT-07:00) Mountain Time - Arizona"},
                {"id": "America/Yellowknife", "text": "(GMT-07:00) Mountain Time - Yellowknife"},
                {"id": "America/Belize", "text": "(GMT-06:00) Belize"},
                {"id": "America/Chicago", "text": "(GMT-06:00) Central Time"},
                {"id": "America/Costa_Rica", "text": "(GMT-06:00) Costa Rica"},
                {"id": "America/El_Salvador", "text": "(GMT-06:00) El Salvador"},
                {"id": "America/Guatemala", "text": "(GMT-06:00) Guatemala"},
                {"id": "America/Managua", "text": "(GMT-06:00) Managua"},
                {"id": "America/Mexico_City", "text": "(GMT-06:00) Central Time - Mexico City"},
                {"id": "America/Regina", "text": "(GMT-06:00) Central Time - Regina"},
                {"id": "America/Tegucigalpa", "text": "(GMT-06:00) Central Time - Tegucigalpa"},
                {"id": "America/Winnipeg", "text": "(GMT-06:00) Central Time - Winnipeg"},
                {"id": "Pacific/Galapagos", "text": "(GMT-06:00) Galapagos"},
                {"id": "America/Bogota", "text": "(GMT-05:00) Bogota"},
                {"id": "America/Cancun", "text": "(GMT-05:00) America Cancun"},
                {"id": "America/Cayman", "text": "(GMT-05:00) Cayman"},
                {"id": "America/Guayaquil", "text": "(GMT-05:00) Guayaquil"},
                {"id": "America/Havana", "text": "(GMT-05:00) Havana"},
                {"id": "America/Iqaluit", "text": "(GMT-05:00) Eastern Time - Iqaluit"},
                {"id": "America/Jamaica", "text": "(GMT-05:00) Jamaica"},
                {"id": "America/Lima", "text": "(GMT-05:00) Lima"},
                {"id": "America/Nassau", "text": "(GMT-05:00) Nassau"},
                {"id": "America/New_York", "text": "(GMT-05:00) Eastern Time"},
                {"id": "America/Panama", "text": "(GMT-05:00) Panama"},
                {"id": "America/Port-au-Prince", "text": "(GMT-05:00) Port-au-Prince"},
                {"id": "America/Rio_Branco", "text": "(GMT-05:00) Rio Branco"},
                {"id": "America/Toronto", "text": "(GMT-05:00) Eastern Time - Toronto"},
                {"id": "Pacific/Easter", "text": "(GMT-05:00) Easter Island"},
                {"id": "America/Caracas", "text": "(GMT-04:00) Caracas"},
                {"id": "America/Asuncion", "text": "(GMT-03:00) Asuncion"},
                {"id": "America/Barbados", "text": "(GMT-04:00) Barbados"},
                {"id": "America/Boa_Vista", "text": "(GMT-04:00) Boa Vista"},
                {"id": "America/Campo_Grande", "text": "(GMT-03:00) Campo Grande"},
                {"id": "America/Cuiaba", "text": "(GMT-03:00) Cuiaba"},
                {"id": "America/Curacao", "text": "(GMT-04:00) Curacao"},
                {"id": "America/Grand_Turk", "text": "(GMT-04:00) Grand Turk"},
                {"id": "America/Guyana", "text": "(GMT-04:00) Guyana"},
                {"id": "America/Halifax", "text": "(GMT-04:00) Atlantic Time - Halifax"},
                {"id": "America/La_Paz", "text": "(GMT-04:00) La Paz"},
                {"id": "America/Manaus", "text": "(GMT-04:00) Manaus"},
                {"id": "America/Martinique", "text": "(GMT-04:00) Martinique"},
                {"id": "America/Port_of_Spain", "text": "(GMT-04:00) Port of Spain"},
                {"id": "America/Porto_Velho", "text": "(GMT-04:00) Porto Velho"},
                {"id": "America/Puerto_Rico", "text": "(GMT-04:00) Puerto Rico"},
                {"id": "America/Santo_Domingo", "text": "(GMT-04:00) Santo Domingo"},
                {"id": "America/Thule", "text": "(GMT-04:00) Thule"},
                {"id": "Atlantic/Bermuda", "text": "(GMT-04:00) Bermuda"},
                {"id": "America/St_Johns", "text": "(GMT-03:30) Newfoundland Time - St. Johns"},
                {"id": "America/Araguaina", "text": "(GMT-03:00) Araguaina"},
                {"id": "America/Argentina/Buenos_Aires", "text": "(GMT-03:00) Buenos Aires"},
                {"id": "America/Bahia", "text": "(GMT-03:00) Salvador"},
                {"id": "America/Belem", "text": "(GMT-03:00) Belem"},
                {"id": "America/Cayenne", "text": "(GMT-03:00) Cayenne"},
                {"id": "America/Fortaleza", "text": "(GMT-03:00) Fortaleza"},
                {"id": "America/Godthab", "text": "(GMT-03:00) Godthab"},
                {"id": "America/Maceio", "text": "(GMT-03:00) Maceio"},
                {"id": "America/Miquelon", "text": "(GMT-03:00) Miquelon"},
                {"id": "America/Montevideo", "text": "(GMT-03:00) Montevideo"},
                {"id": "America/Paramaribo", "text": "(GMT-03:00) Paramaribo"},
                {"id": "America/Recife", "text": "(GMT-03:00) Recife"},
                {"id": "America/Santiago", "text": "(GMT-03:00) Santiago"},
                {"id": "America/Sao_Paulo", "text": "(GMT-03:00) Sao Paulo"},
                {"id": "Antarctica/Palmer", "text": "(GMT-03:00) Palmer"},
                {"id": "Antarctica/Rothera", "text": "(GMT-03:00) Rothera"},
                {"id": "Atlantic/Stanley", "text": "(GMT-03:00) Stanley"},
                {"id": "America/Noronha", "text": "(GMT-02:00) Noronha"},
                {"id": "Atlantic/South_Georgia", "text": "(GMT-02:00) South Georgia"},
                {"id": "America/Scoresbysund", "text": "(GMT-01:00) Scoresbysund"},
                {"id": "Atlantic/Azores", "text": "(GMT-01:00) Azores"},
                {"id": "Atlantic/Cape_Verde", "text": "(GMT-01:00) Cape Verde"},
                {"id": "Africa/Abidjan", "text": "(GMT+00:00) Abidjan"},
                {"id": "Africa/Accra", "text": "(GMT+00:00) Accra"},
                {"id": "Africa/Bissau", "text": "(GMT+00:00) Bissau"},
                {"id": "Africa/Casablanca", "text": "(GMT+00:00) Casablanca"},
                {"id": "Africa/El_Aaiun", "text": "(GMT+00:00) El Aaiun"},
                {"id": "Africa/Monrovia", "text": "(GMT+00:00) Monrovia"},
                {"id": "America/Danmarkshavn", "text": "(GMT+00:00) Danmarkshavn"},
                {"id": "Atlantic/Canary", "text": "(GMT+00:00) Canary Islands"},
                {"id": "Atlantic/Faroe", "text": "(GMT+00:00) Faeroe"},
                {"id": "Atlantic/Reykjavik", "text": "(GMT+00:00) Reykjavik"},
                {"id": "Etc/GMT", "text": "(GMT+00:00) GMT (no daylight saving)"},
                {"id": "Europe/Dublin", "text": "(GMT+00:00) Dublin"},
                {"id": "Europe/Lisbon", "text": "(GMT+00:00) Lisbon"},
                {"id": "Europe/London", "text": "(GMT+00:00) London"},
                {"id": "Africa/Algiers", "text": "(GMT+01:00) Algiers"},
                {"id": "Africa/Ceuta", "text": "(GMT+01:00) Ceuta"},
                {"id": "Africa/Lagos", "text": "(GMT+01:00) Lagos"},
                {"id": "Africa/Ndjamena", "text": "(GMT+01:00) Ndjamena"},
                {"id": "Africa/Tunis", "text": "(GMT+01:00) Tunis"},
                {"id": "Africa/Windhoek", "text": "(GMT+02:00) Windhoek"},
                {"id": "Europe/Amsterdam", "text": "(GMT+01:00) Amsterdam"},
                {"id": "Europe/Andorra", "text": "(GMT+01:00) Andorra"},
                {"id": "Europe/Belgrade", "text": "(GMT+01:00) Central European Time - Belgrade"},
                {"id": "Europe/Berlin", "text": "(GMT+01:00) Berlin"},
                {"id": "Europe/Brussels", "text": "(GMT+01:00) Brussels"},
                {"id": "Europe/Budapest", "text": "(GMT+01:00) Budapest"},
                {"id": "Europe/Copenhagen", "text": "(GMT+01:00) Copenhagen"},
                {"id": "Europe/Gibraltar", "text": "(GMT+01:00) Gibraltar"},
                {"id": "Europe/Luxembourg", "text": "(GMT+01:00) Luxembourg"},
                {"id": "Europe/Madrid", "text": "(GMT+01:00) Madrid"},
                {"id": "Europe/Malta", "text": "(GMT+01:00) Malta"},
                {"id": "Europe/Monaco", "text": "(GMT+01:00) Monaco"},
                {"id": "Europe/Oslo", "text": "(GMT+01:00) Oslo"},
                {"id": "Europe/Paris", "text": "(GMT+01:00) Paris"},
                {"id": "Europe/Prague", "text": "(GMT+01:00) Central European Time - Prague"},
                {"id": "Europe/Rome", "text": "(GMT+01:00) Rome"},
                {"id": "Europe/Stockholm", "text": "(GMT+01:00) Stockholm"},
                {"id": "Europe/Tirane", "text": "(GMT+01:00) Tirane"},
                {"id": "Europe/Vienna", "text": "(GMT+01:00) Vienna"},
                {"id": "Europe/Warsaw", "text": "(GMT+01:00) Warsaw"},
                {"id": "Europe/Zurich", "text": "(GMT+01:00) Zurich"},
                {"id": "Africa/Cairo", "text": "(GMT+02:00) Cairo"},
                {"id": "Africa/Johannesburg", "text": "(GMT+02:00) Johannesburg"},
                {"id": "Africa/Maputo", "text": "(GMT+02:00) Maputo"},
                {"id": "Africa/Tripoli", "text": "(GMT+02:00) Tripoli"},
                {"id": "Asia/Amman", "text": "(GMT+02:00) Amman"},
                {"id": "Asia/Beirut", "text": "(GMT+02:00) Beirut"},
                {"id": "Asia/Damascus", "text": "(GMT+02:00) Damascus"},
                {"id": "Asia/Gaza", "text": "(GMT+02:00) Gaza"},
                {"id": "Asia/Jerusalem", "text": "(GMT+02:00) Jerusalem"},
                {"id": "Asia/Nicosia", "text": "(GMT+02:00) Nicosia"},
                {"id": "Europe/Athens", "text": "(GMT+02:00) Athens"},
                {"id": "Europe/Bucharest", "text": "(GMT+02:00) Bucharest"},
                {"id": "Europe/Chisinau", "text": "(GMT+02:00) Chisinau"},
                {"id": "Europe/Helsinki", "text": "(GMT+02:00) Helsinki"},
                {"id": "Europe/Istanbul", "text": "(GMT+03:00) Istanbul"},
                {"id": "Europe/Kaliningrad", "text": "(GMT+02:00) Moscow-01 - Kaliningrad"},
                {"id": "Europe/Kyiv", "text": "(GMT+02:00) Kyiv"},
                {"id": "Europe/Riga", "text": "(GMT+02:00) Riga"},
                {"id": "Europe/Sofia", "text": "(GMT+02:00) Sofia"},
                {"id": "Europe/Tallinn", "text": "(GMT+02:00) Tallinn"},
                {"id": "Europe/Vilnius", "text": "(GMT+02:00) Vilnius"},
                {"id": "Africa/Khartoum", "text": "(GMT+03:00) Khartoum"},
                {"id": "Africa/Nairobi", "text": "(GMT+03:00) Nairobi"},
                {"id": "Antarctica/Syowa", "text": "(GMT+03:00) Syowa"},
                {"id": "Asia/Baghdad", "text": "(GMT+03:00) Baghdad"},
                {"id": "Asia/Qatar", "text": "(GMT+03:00) Qatar"},
                {"id": "Asia/Riyadh", "text": "(GMT+03:00) Riyadh"},
                {"id": "Europe/Minsk", "text": "(GMT+03:00) Minsk"},
                {"id": "Europe/Moscow", "text": "(GMT+03:00) Moscow+00 - Moscow"},
                {"id": "Asia/Tehran", "text": "(GMT+03:30) Tehran"},
                {"id": "Asia/Baku", "text": "(GMT+04:00) Baku"},
                {"id": "Asia/Dubai", "text": "(GMT+04:00) Dubai"},
                {"id": "Asia/Tbilisi", "text": "(GMT+04:00) Tbilisi"},
                {"id": "Asia/Yerevan", "text": "(GMT+04:00) Yerevan"},
                {"id": "Europe/Samara", "text": "(GMT+04:00) Moscow+01 - Samara"},
                {"id": "Indian/Mahe", "text": "(GMT+04:00) Mahe"},
                {"id": "Indian/Mauritius", "text": "(GMT+04:00) Mauritius"},
                {"id": "Indian/Reunion", "text": "(GMT+04:00) Reunion"},
                {"id": "Asia/Kabul", "text": "(GMT+04:30) Kabul"},
                {"id": "Antarctica/Mawson", "text": "(GMT+05:00) Mawson"},
                {"id": "Asia/Aqtau", "text": "(GMT+05:00) Aqtau"},
                {"id": "Asia/Aqtobe", "text": "(GMT+05:00) Aqtobe"},
                {"id": "Asia/Ashgabat", "text": "(GMT+05:00) Ashgabat"},
                {"id": "Asia/Dushanbe", "text": "(GMT+05:00) Dushanbe"},
                {"id": "Asia/Karachi", "text": "(GMT+05:00) Karachi"},
                {"id": "Asia/Tashkent", "text": "(GMT+05:00) Tashkent"},
                {"id": "Asia/Yekaterinburg", "text": "(GMT+05:00) Moscow+02 - Yekaterinburg"},
                {"id": "Indian/Kerguelen", "text": "(GMT+05:00) Kerguelen"},
                {"id": "Indian/Maldives", "text": "(GMT+05:00) Maldives"},
                {"id": "Asia/Calcutta", "text": "(GMT+05:30) India Standard Time"},
                {"id": "Asia/Colombo", "text": "(GMT+05:30) Colombo"},
                {"id": "Asia/Katmandu", "text": "(GMT+05:45) Katmandu"},
                {"id": "Antarctica/Vostok", "text": "(GMT+06:00) Vostok"},
                {"id": "Asia/Almaty", "text": "(GMT+06:00) Almaty"},
                {"id": "Asia/Bishkek", "text": "(GMT+06:00) Bishkek"},
                {"id": "Asia/Dhaka", "text": "(GMT+06:00) Dhaka"},
                {"id": "Asia/Omsk", "text": "(GMT+06:00) Moscow+03 - Omsk, Novosibirsk"},
                {"id": "Asia/Thimphu", "text": "(GMT+06:00) Thimphu"},
                {"id": "Indian/Chagos", "text": "(GMT+06:00) Chagos"},
                {"id": "Asia/Rangoon", "text": "(GMT+06:30) Rangoon"},
                {"id": "Indian/Cocos", "text": "(GMT+06:30) Cocos"},
                {"id": "Antarctica/Davis", "text": "(GMT+07:00) Davis"},
                {"id": "Asia/Bangkok", "text": "(GMT+07:00) Bangkok"},
                {"id": "Asia/Hovd", "text": "(GMT+07:00) Hovd"},
                {"id": "Asia/Jakarta", "text": "(GMT+07:00) Jakarta"},
                {"id": "Asia/Krasnoyarsk", "text": "(GMT+07:00) Moscow+04 - Krasnoyarsk"},
                {"id": "Asia/Saigon", "text": "(GMT+07:00) Hanoi"},
                {"id": "Asia/Ho_Chi_Minh", "text": "(GMT+07:00) Ho Chi Minh"},
                {"id": "Indian/Christmas", "text": "(GMT+07:00) Christmas"},
                {"id": "Antarctica/Casey", "text": "(GMT+08:00) Casey"},
                {"id": "Asia/Brunei", "text": "(GMT+08:00) Brunei"},
                {"id": "Asia/Choibalsan", "text": "(GMT+08:00) Choibalsan"},
                {"id": "Asia/Hong_Kong", "text": "(GMT+08:00) Hong Kong"},
                {"id": "Asia/Irkutsk", "text": "(GMT+08:00) Moscow+05 - Irkutsk"},
                {"id": "Asia/Kuala_Lumpur", "text": "(GMT+08:00) Kuala Lumpur"},
                {"id": "Asia/Macau", "text": "(GMT+08:00) Macau"},
                {"id": "Asia/Makassar", "text": "(GMT+08:00) Makassar"},
                {"id": "Asia/Manila", "text": "(GMT+08:00) Manila"},
                {"id": "Asia/Shanghai", "text": "(GMT+08:00) China Time - Beijing"},
                {"id": "Asia/Singapore", "text": "(GMT+08:00) Singapore"},
                {"id": "Asia/Taipei", "text": "(GMT+08:00) Taipei"},
                {"id": "Asia/Ulaanbaatar", "text": "(GMT+08:00) Ulaanbaatar"},
                {"id": "Australia/Perth", "text": "(GMT+08:00) Western Time - Perth"},
                {"id": "Asia/Pyongyang", "text": "(GMT+08:30) Pyongyang"},
                {"id": "Asia/Dili", "text": "(GMT+09:00) Dili"},
                {"id": "Asia/Jayapura", "text": "(GMT+09:00) Jayapura"},
                {"id": "Asia/Seoul", "text": "(GMT+09:00) Seoul"},
                {"id": "Asia/Tokyo", "text": "(GMT+09:00) Tokyo"},
                {"id": "Asia/Yakutsk", "text": "(GMT+09:00) Moscow+06 - Yakutsk"},
                {"id": "Pacific/Palau", "text": "(GMT+09:00) Palau"},
                {"id": "Australia/Adelaide", "text": "(GMT+10:30) Central Time - Adelaide"},
                {"id": "Australia/Darwin", "text": "(GMT+09:30) Central Time - Darwin"},
                {"id": "Antarctica/DumontDUrville", "text": "(GMT+10:00) Dumont D'Urville"},
                {"id": "Asia/Magadan", "text": "(GMT+10:00) Moscow+07 - Magadan"},
                {"id": "Asia/Vladivostok", "text": "(GMT+10:00) Moscow+07 - Vladivostok"},
                {"id": "Australia/Brisbane", "text": "(GMT+10:00) Eastern Time - Brisbane"},
                {"id": "Asia/Yuzhno-Sakhalinsk", "text": "(GMT+11:00) Moscow+08 - Yuzhno-Sakhalinsk"},
                {"id": "Australia/Hobart", "text": "(GMT+11:00) Eastern Time - Hobart"},
                {"id": "Australia/Sydney", "text": "(GMT+11:00) Eastern Time - Melbourne, Sydney"},
                {"id": "Pacific/Chuuk", "text": "(GMT+10:00) Truk"},
                {"id": "Pacific/Guam", "text": "(GMT+10:00) Guam"},
                {"id": "Pacific/Port_Moresby", "text": "(GMT+10:00) Port Moresby"},
                {"id": "Pacific/Efate", "text": "(GMT+11:00) Efate"},
                {"id": "Pacific/Guadalcanal", "text": "(GMT+11:00) Guadalcanal"},
                {"id": "Pacific/Kosrae", "text": "(GMT+11:00) Kosrae"},
                {"id": "Pacific/Norfolk", "text": "(GMT+11:00) Norfolk"},
                {"id": "Pacific/Noumea", "text": "(GMT+11:00) Noumea"},
                {"id": "Pacific/Pohnpei", "text": "(GMT+11:00) Ponape"},
                {"id": "Asia/Kamchatka", "text": "(GMT+12:00) Moscow+09 - Petropavlovsk-Kamchatskiy"},
                {"id": "Pacific/Auckland", "text": "(GMT+13:00) Auckland"},
                {"id": "Pacific/Fiji", "text": "(GMT+13:00) Fiji"},
                {"id": "Pacific/Funafuti", "text": "(GMT+12:00) Funafuti"},
                {"id": "Pacific/Kwajalein", "text": "(GMT+12:00) Kwajalein"},
                {"id": "Pacific/Majuro", "text": "(GMT+12:00) Majuro"},
                {"id": "Pacific/Nauru", "text": "(GMT+12:00) Nauru"},
                {"id": "Pacific/Tarawa", "text": "(GMT+12:00) Tarawa"},
                {"id": "Pacific/Wake", "text": "(GMT+12:00) Wake"},
                {"id": "Pacific/Wallis", "text": "(GMT+12:00) Wallis"},
                {"id": "Pacific/Apia", "text": "(GMT+14:00) Apia"},
                {"id": "Pacific/Enderbury", "text": "(GMT+13:00) Enderbury"},
                {"id": "Pacific/Fakaofo", "text": "(GMT+13:00) Fakaofo"},
                {"id": "Pacific/Tongatapu", "text": "(GMT+13:00) Tongatapu"},
                {"id": "Pacific/Kiritimati", "text": "(GMT+14:00) Kiritimati"}
            ],
            users: [],
            userOptions: [],
            isValidated: true,
        }
    },
    created() {
        this.appointment = this.$props.appointmentData;

        // Prepare start and end time object for VueDatePicker
        if (this.addOrEdit == 'edit') {
            const startTime = moment(this.$props.appointmentData.start_time, 'HH:mm:ss');
            const endTime = moment(this.$props.appointmentData.end_time, 'HH:mm:ss');
            this.appointment.start_time = {
                hours: startTime.hours(),
                minutes: startTime.minutes()
            };
            this.appointment.end_time = {
                hours: endTime.hours(),
                minutes: endTime.minutes()
            };

            // Check if users is available then pre fill the assigned users
            if (this.$props.appointmentData.users && this.$props.appointmentData.users.length > 0) {

                this.appointment.assigned_to = this.$props.appointmentData.users.map((user) => {
                    // Prepare the roles in comma separated string
                    user.roles = user.roles
                            //.map(role => role.name.charAt(0).toUpperCase() + role.name.slice(1))
                            .map(role => role.name.replace(/_/g, ' ')
                            .replace(/\b\w/g, char => char.toUpperCase()))
                            .join(', ');
                    return {
                        id: user.id,
                        name: user.name,
                        email: user.email,
                        name_with_email: user.name + ' (' + user.email + ') — ' + user.roles,
                    }
                });
            }
        }

        this.getUsers();
    },
    mounted() {

    },
    methods: {
        async createOrAppointment() {
            // Validate the form
            if(this.appointment.title === '' || this.appointment.name === '') {
                this.isValidated = false;
                return;
            }
            this.processing = true;
            if(this.addOrEdit == 'add') {
                await axios.post('/admin/appointments', this.appointment)
                    .then(response => {
                        this.$notification(response.data.status,response.data.message)
                        if (response.data.status === 'success') {
                            window.location.href = response.data.redirect_url;
                        }
                    })
                    .catch(error => {
                        this.processing = false;
                        this.errors = error.response.data.errors;
                    });
            }
            else {
                let url = '/admin/appointments/' + this.appointment.id;
                axios.patch(url, this.appointment)
                    .then(response => {
                        this.$notification(response.data.status,response.data.message)
                        if (response.data.status === 'success') {
                            window.location.href = response.data.redirect_url;
                        }
                    })
                    .catch(error => {
                        this.processing = false;
                        this.errors = error.response.data.errors;
                    });
            }
        },
        getUsers() {
            let self = this;
            axios.post('/admin/staff/get-list')
                .then(response => {
                    self.users = response.data.users;
                    self.userOptions = response.data.users.map(user => {
                        // Prepare the roles in comma separated string
                        user.roles = user.roles
                            //.map(role => role.name.charAt(0).toUpperCase() + role.name.slice(1))
                            .map(role => role.name.replace(/_/g, ' ')
                            .replace(/\b\w/g, char => char.toUpperCase()))
                            .join(', ');
                        return {
                            id: user.id,
                            name: user.name,
                            email: user.email,
                            name_with_email: user.name + ' (' + user.email + ') — ' + user.roles,
                        }
                    });
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }
}
</script>
